import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CompetenciaService {
  private readonly path = 'profissionais';

  constructor(private apiService: ApiService) {}

  list(params: any): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllCompetencia`,
      this.getParams(params),
      true
    );
  }
  show(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getCompetenciaById/${id}`,
      this.getParams(),
      true
    );
  }
  add(data: any): Observable<any> {
    return this.apiService.post(`${this.path}/AddCompetencia`, data, {}, true);
  }
  update(data: any): Observable<any> {
    return this.apiService.put(
      `${this.path}/UpdateCompetencia`,
      data,
      this.getParams(),
      true
    );
  }
  delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteCompetenciaById/${id}`,
      this.getParams(),
      true
    );
  }

  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}
